export enum A48ActivityType {
    HOURS = 1,
    CREDITS = 2
}
